import ApiClient from '../ApiClient';

class CrmDealOriginsAPI extends ApiClient {
    constructor() {
        super('crm/deal_origins', { accountScoped: true });
    }
}
export default new CrmDealOriginsAPI();
